<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Repacking Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
				<app-input-combobox-autocomplete :options="repackStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Repack Status" id="input-" size="sm" :model.sync="model.repackStatusId" :isRequired="true" :state="validateState('repackStatusId')" :errorMessage="getErrorMessage(errorMessage.repackStatusId, 'repackStatusId')"   :selected="model.repackStatus != null ? model.repackStatus.name : ''" @input="getRepackStatuss" />
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Repack By" id="input-" size="sm" :model.sync="model.repackById"   :selected="model.repackBy != null ? model.repackBy.firstName : ''" @input="getUserInfos" />
				<app-input-datetimepicker id="fieldset-start-date" label-cols-lg="12" label="Start Date" size="sm" :model.sync="model.startDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-datetimepicker id="fieldset-finish-date" label-cols-lg="12" label="Finish Date" size="sm" :model.sync="model.finishDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />
				<app-input-textbox id="fieldset-qty-repack" label-cols-lg="12" label="Qty Repack" label-for="input-qty-repack" size="sm" :model.sync="model.qtyRepack"  />
				<app-input-textbox id="fieldset-qty-outstanding" label-cols-lg="12" label="Qty Outstanding" label-for="input-qty-outstanding" size="sm" :model.sync="model.qtyOutstanding"  />
				<app-input-textbox id="fieldset-qty-fullfiled" label-cols-lg="12" label="Qty Fullfiled" label-for="input-qty-fullfiled" size="sm" :model.sync="model.qtyFullfiled"  />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import RepackingDetail from '@/models/Repacking/RepackingDetail';
import RepackingDetailFilter from '@/filters/Repacking/RepackingDetailFilter';

import Repacking from '@/models/Repacking/Repacking';
import RepackingFilter from '@/filters/Repacking/RepackingFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import RepackStatus from '@/models/RepackStatus/RepackStatus';
import RepackStatusFilter from '@/filters/RepackStatus/RepackStatusFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PopupRouterView,
		AppInputScan,
	},
	mixins : [validationMixin, focusInput],
	validations: {
		model: {
		deliveryInstructionDetailId: {required},
		partId: {required},
		repackStatusId: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				deliveryInstructionDetailId: { required : "Delivery Instruction Detail is Required."},
				partId: { required : "Part is Required."},
				repackStatusId: { required : "Repack Status is Required."},
			},
			deliveryInstructionDetails : [],
			parts : [],
			repackStatuss : [],
			userInfos : [],
			isBusy: false,
		}
	},
	methods : {
		getRepackingDetail : async function(id) {
			this.isBusy = true;
			RepackingDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getRepackStatuss : async function(input) {
			let filter = new RepackStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			RepackStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.repackStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},
		scanDeliveryInstructionDetail() {
			this.focusInput(this, "fieldset-deliveryinstructiondetail");
		},
		scanPart() {
			this.focusInput(this, "fieldset-part");
		},

	},	beforeMount() {
		//this.getDeliveryInstructionDetails();
		//this.getParts();
		//this.getRepackStatuss();
		//this.getUserInfos();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getRepackingDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getDeliveryInstructionDetails();
				this.getParts();
				this.getRepackStatuss();
				this.getUserInfos();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getRepackingDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
